import Phaser from "phaser";
import * as THREE from "three";
import GameConfig from "../config";
import SoundManager from "../sound/SoundManager";
import SceneUtils from "../utils/sceneUtils";
import DbClient from "../db/client";
import Stats from 'three/examples/jsm/libs/stats.module.js'
import DebugStats from "../utils/debugStats";
import LocalStorage from "../utils/localStorage";
import initLoader from "../loader/initLoader";
import {setupBuild} from "../external/setup";

export default class Boot extends Phaser.Scene {
    constructor () {
        super('Boot');
    }

    preload () {
        initLoader(this);
        this.load.image('board', 'src/assets/img/board2.png');
        this.load.image('background', 'src/assets/img/star_fire.jpg');
        this.load.image('title', 'src/assets/img/logo.png');
        this.load.image('btn_home', 'src/assets/img/home_btn.png');
        this.load.image('name_background', 'src/assets/img/board3.png');
        SoundManager.preloadMenu(this);
    }

    create () {
        setupBuild(this.game);
        SoundManager.init(this.game);
        SoundManager.addFX("button_click", 0.7);
        SoundManager.addFX("intro", 0.7);
        SoundManager.playMusic("intro", true);
        DbClient.init({url: GameConfig.HIGHSCORE.URL});
        this.game.threeScene = new THREE.Scene();
        this.game.threeCamera = new THREE.PerspectiveCamera(
            GameConfig.CAMERA.FOV,
            this.game.config.width/this.game.config.height,
            GameConfig.CAMERA.NEAR,
            GameConfig.CAMERA.FAR);

        this.game.threeRenderer = new THREE.WebGLRenderer();


        this.game.threeRenderer.setSize( this.game.config.width, this.game.config.height );

        this.game.threeRenderer.setPixelRatio(devicePixelRatio);
        //this.game.threeRenderer.shadowMap.enabled = true;
        this.game.threeRenderer.antialias = true;

        THREE.ColorManagement.legacyMode = false

        this.game.threeRenderer.shadowMap.type = THREE.PCFSoftShadowMap; // default THREE.PCFShadowMap
        this.game.threeRenderer.outputEncoding = THREE.sRGBEncoding;
        this.game.threeRenderer.toneMapping = THREE.ACESFilmicToneMapping;

        document.getElementById("three-app").append( this.game.threeRenderer.domElement );

        this.loadFont("Splurge", "src/assets/fonts/splurge.ttf");
        SceneUtils.resize(this);
        this.scale.on("resize", () => this.scale.on("resize", () => SceneUtils.resize(this)));

        if(GameConfig.DEBUG.ON) {
            this.game.stats = new Stats()
            this.game.stats.showPanel(0) // 0: fps, 1: ms, 2: mb, 3+: custom
            document.body.appendChild(this.game.stats.dom);
            DebugStats.init();
        }

        const logo = document.getElementById("brand-image");
        logo.parentElement.removeChild(logo);

        if(LocalStorage.isPlayerNameSet()){
            this.scene.start('Menu');
        } else {
            this.scene.start('NameInput');
        }
    }

    loadFont(name, url) {
        var newFont = new FontFace(name, `url(${url})`);
        newFont.load().then(function (loaded) {
            document.fonts.add(loaded);
        }).catch(function (error) {
            return error;
        });
    }
}